// import localMixin from "./Mixins/DailyReport";
import axios from "axios";
import moment from "moment";
import TaskStatusAddComponent from "../../components/TaskStatusAddComponent.vue";
import TaskCommentComponent from "../../components/TaskcommentComponent.vue";
import TaskAddToComponent from "../../components/TaskAddToComponent.vue";
import Tooltip from "../../components/Tooltip.vue";
import Swal from "sweetalert2";
import TaskAuditLog from "../../components/TasksAuditLog.vue";
import AuditLogComponent from "../../components/AuditLogComponent.vue";

// import Multiselect from "@vueform/multiselect";
// import Swal from "sweetalert2";

export default {
  name: "PatientTask",
  components: {
    Tooltip,
    TaskAuditLog,
    TaskStatusAddComponent,
    TaskCommentComponent,
    TaskAddToComponent,
    AuditLogComponent,
    // Multiselect,
  },

  data() {
    return {
      MassUpdateDialog: false,
      MassUpdateFormSelectedValue: "0",
      MassUpdateValue: 0,
      cities: [
        { name: "New York", code: "NY" },
        { name: "Rome", code: "RM" },
        { name: "London", code: "LDN" },
        { name: "Istanbul", code: "IST" },
        { name: "Paris", code: "PRS" },
      ],
      currentPatientTask: {}, //task whos status is to be Changed
      displayAuditLog: false,
      AddTaskStatusModal: false,
      commentShowModal: false,
      AddTaskModal: false,
      search: null,
      userid: 0,
      interval: 0,
      TimerObject: {},
      pageSize: 50,
      pageNumber: 1,
      totalRows: 0,
      totalPages: 10,
      initDatePR: "",
      showPagesMin: 1,
      showPagesMax: 5,
      startDatePR: {},
      endDatePR: {},
      Users: [],
      Tasks: [],
      TasksStatus: [],
      SelectedUsers: [],
      SelectedTasks: [],
      SelectedTasksStatus: [],
      PatientTasks: [],
      sortCol: 0,
      sortOption: true,
      patientTask: null,
    };
  }, // data

  methods: {
    UpdateMassForm() {
      let visitTaskIds = this.PatientTasks.map((item) => {
        return item.visitTaskId;
      });

      let totalCount = visitTaskIds.length;

      Swal.fire({
        title: `You are about to change status for ${totalCount} records.`,
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#C7604D",
            cancelButtonColor: "#999999",
            confirmButtonText: "Update",
          }).then((result) => {
            if (result.isConfirmed) {
              this.UpdateMassPatientTaskStatus(visitTaskIds);
            }
          });
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    },
    OpenMassUpdateDialog() {
      this.MassUpdateDialog = true;
    },
    convertItInSortAndGroupList(taskStatusList) {
      const sortedStatusList = taskStatusList.sort(
        ({ closeTask: a }, { closeTask: b }) => (a === b ? 0 : a ? 1 : -1),
      );

      const groupedStatusList = sortedStatusList.reduce(
        (groups, { taskStatusId, statusName, closeTask }) => {
          const groupLabel = closeTask === false ? "Open" : "Closed";
          const group = groups.find(({ label }) => label === groupLabel);
          if (group) {
            group.items.push({ taskStatusId, statusName });
          } else {
            groups.push({
              label: groupLabel,
              items: [{ taskStatusId, statusName }],
            });
          }
          return groups;
        },
        [],
      );

      return groupedStatusList;
    },

    showAuditLog(pt) {
      this.displayAuditLog = true;
      this.$nextTick(() => {
        try {
          this.$refs.auditLogComponent.loadInitVisit(
            pt.visitId,
            pt.visitTaskId,
            pt.taskID,
          );
        } catch {
          return -1;
        }
      });
    },
    getAuditLogByVisitTaskIdAndTaskId(pt) {
      debugger;
      this.displayAuditLog = true;
      this.$nextTick(() => {
        try {
          this.$refs.auditLogComponent.getAuditLogByVisitTaskIdAndTaskId(
            pt.visitId,
            0,
            pt.taskID,
          );
        } catch {
          return -1;
        }
      });
    },
    ShowTaskAddTo() {
      this.AddTaskModal = true;
    },
    CloseTaskAddTo() {
      this.AddTaskModal = false;
    },
    datePickerPR() {
      const self = this;
      $('input[name="daterangePR"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDatePR = new Date(start);
          self.endDatePR = new Date(end);
          self.initDatePR =
            self.dateToMDY(self.startDatePR) +
            " - " +
            self.dateToMDY(self.endDatePR);
        },
      );
    },
    loadInit() {
      this.intDummyComm();
      this.getTableFilters();
      this.getTableData();
    },
    async UpdateMassPatientTaskStatus(visitTaskIds) {
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      var obj = {
        VisitTaskId: visitTaskIds,
        TaskStatusId: this.MassUpdateValue.id,
        DC: this.dummyComm,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/UpdateMassPatientTaskStatus",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          if (res.data.status === true) {
            this.MassUpdateFormSelectedValue = "0";
            this.MassUpdateValue = 0;
            this.MassUpdateDialog = false;
            this.getTableData();
            Swal.fire({
              icon: "success",
              title: "Updated",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },
    async getTableFilters() {
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetTaskDetailsAll",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data.data;
          this.TasksStatus = myData.taskStatusGroup;
          this.Tasks = myData.allTasks;
          this.Users = myData.usersGroups;
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },
    getComment(visitTaskId, pt) {
      this.patientTask = pt;
      this.commentShowModal = true;
      this.$refs.taskComment.GetComment(visitTaskId);
    },
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      //show pagination
      if (this.showPagesMax / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
      } else if (this.showPagesMin / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
        if (this.showPagesMax < 5) {
          this.showPagesMax = 5;
        }
      } else {
        this.showPagesMin = 1;
        this.showPagesMax = 5;
      }
      //show pagination
      this.loadInit();
    },
    async getTableDataA() {
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.pageNumber = this.pageNumber;

      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetAllPatientTasksTable",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.PatientTasks = myData.data;
            this.totalRows = this.PatientTasks[0].total;
            this.totalPages = this.PatientTasks[0].totalPages;
          } else {
            this.error;
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },
    SearchDataTable() {
      this.getTableData();
    },
    async getTableData() {
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.pageNumber = this.pageNumber;
      const userIds = this.SelectedUsers.map(function (x) {
        return x.userId;
      });
      const taskIds = this.SelectedTasks.map(function (x) {
        return x.taskID;
      });
      const statusIds = this.SelectedTasksStatus.map(function (x) {
        return x.id;
      });
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      const obj = {
        userIds: userIds,
        taskIds: taskIds,
        statusIds: statusIds,
        DC: this.dummyComm,
        startDate: this.dateToSqlServerDateFormat(this.startDatePR), //moment(this.startDatePR),
        endDate: this.dateToSqlServerDateFormat(this.endDatePR),
        sortCol: this.sortCol,
        sortOption: this.sortOption,
        Search: this.search,
      };

      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetAllPatientTasksTable",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.PatientTasks = myData.data;
            this.totalRows = this.PatientTasks[0].total;
            this.totalPages = this.PatientTasks[0].totalPages;

            if (this.pageNumber > this.totalPages) this.pageNumber = 1;
          } else {
            this.error;
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },
    async getTableDataWithOutLoad() {
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.pageNumber = this.pageNumber;
      const userIds = this.SelectedUsers.map(function (x) {
        return x.userId;
      });
      const taskIds = this.SelectedTasks.map(function (x) {
        return x.taskID;
      });
      const statusIds = this.SelectedTasksStatus.map(function (x) {
        return x.id;
      });
      const obj = {
        userIds: userIds,
        taskIds: taskIds,
        statusIds: statusIds,
        DC: this.dummyComm,
        startDate: moment(this.startDatePR),
        endDate: moment(this.endDatePR),
        sortCol: this.sortCol,
        sortOption: this.sortOption,
        Search: this.search,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetAllPatientTasksTable",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.PatientTasks = myData.data;

            this.totalRows = this.PatientTasks[0].total;
            this.totalPages = this.PatientTasks[0].totalPages;

            if (this.pageNumber > this.totalPages) this.pageNumber = 1;
          } else {
            this.error;
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    orderBy(sortCol) {
      if (sortCol == this.sortCol) {
        if (this.sortOption == false) {
          this.sortOption = true;
        } else {
          this.sortOption = false;
        }
      } else {
        this.sortOption = true;
      }
      this.sortCol = sortCol;
      this.getTableData();
    },
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ChangeTaskStatus(pt, taskStatus) {
      //taskStatus is zero call modal
      if (taskStatus == 0) {
        this.currentPatientTask = pt;
        this.AddTaskStatusModal = true;
      } //call axios
      else {
        console.log(taskStatus);
        this.ChangeTaskStatusAxios(pt, taskStatus, 0);
      }
    },
    closeTaskStatus() {
      this.AddTaskStatusModal = false;
    },
    async ChangeTaskStatusAxios(pt, taskStatus, what) {
      this.intDummyComm();
      const obj = {
        DC: this.dummyComm,
        TaskStatus: taskStatus,
        VisitTaskId: pt.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/PostAssignStatusToTask",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to update information");
            this.getTableData();
          }
        })
        .finally(() => {
          if (what !== 0) {
            this.getTableData();
          }
          this.ResetLogoutTime();
        });
    },
    AddRemoveUser(e, userSelected, userList, pt) {
      console.log(e);
      pt.loading = true;
      this.AddRemoveUserAxios(userSelected, userList, pt);
    },
    async AddRemoveUserAxios(userSelected, userList, pt) {
      this.intDummyComm();
      const obj = {
        DC: this.dummyComm,
        UserIds: userSelected,
        VisitTaskId: pt.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/TaskAssignAddRemoveUser",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to undate information");
            this.getTableData();
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          pt.loading = false;
        });
    },
    ChangeTaskDueDateIcon(pt, dueDate) {
      pt.dateChangeIcon = true;
    },
    ChangeTaskDueDate(pt, dueDate) {
      this.ChangeTaskDueDateAxios(pt, dueDate);
      // clearTimeout(this.interval);
      // this.interval = setTimeout(() => {
      //   this.ChangeTaskDueDateAxios(pt, dueDate);
      // }, 5000);
    },
    async ChangeTaskDueDateAxios(pt, dueDate) {
      this.intDummyComm();
      this.dummyComm.patientId = pt.patientId;

      const obj = {
        DC: this.dummyComm,
        DueDate: dueDate,
        VisitTaskId: pt.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/PostUpdateDueDateToTask",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to update information");
            this.getTableData();
          }
        })
        .finally(() => {
          pt.dateChangeIcon = false;
          this.ResetLogoutTime();
        });
    },
    TaskNameUpdatedIcon(e, taskName, pt) {
      pt.inputNameIcon = true;
    },
    async TaskNameUpdated(e, taskName, pt) {
      if (taskName.length > 250 || taskName.length == 0) {
        console.log("Prevent Default");
        e.preventDefault();
        return;
      }
      this.intDummyComm();
      this.dummyComm.patientId = pt.patientId;

      const obj = {
        DC: this.dummyComm,
        TaskName: taskName,
        VisitTaskId: pt.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/PostUpdateTaskNamePatient",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to update information");
            this.getTableData();
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          pt.inputNameIcon = false;
        });
    },
    sortUsersSelected(userList, userSelected) {
      //console.log(userList,userSelected);
      userSelected.forEach((x) => {
        var item = userList.find((i) => i.userId == x);
        var index = userList.findIndex((i) => i.userId == x);
        if (item !== undefined) {
          userList.splice(index, 1);
          userList.splice(0, 0, item);
        }
      });
    },
    deleteVisitTaskSwal(pt) {
      Swal.fire({
        icon: "error",
        title: "Are you sure?",
        text: "you want to delete this task and any information related to it.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          this.deleteVisitTaskAxios(pt);
        }
      });
    },
    async deleteVisitTaskAxios(pt) {
      debugger;

      this.intDummyComm();
      this.dummyComm.visitId = pt.visitId;

      const obj = {
        DC: this.dummyComm,
        VisitTaskId: pt.visitTaskId,
        TaskId: pt.taskID,
        PatientId: pt.patientId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/DeletePatientTask",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to update information");
            this.getTableData();
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          this.getTableData();
        });
    },
  }, // methods

  computed: {}, // computed

  watch: {
    initDatePR: function () {
      this.loadInit();
      // console.log(this.initDatePR);
    },
  }, //watch

  mounted() {
    this.intDummyComm();
    const str = localStorage.OSversion;
    const arr = str.split(this.UKEY);

    this.userid = arr[0] * 1;
    this.StartLogoutTime();
    const dd = new Date();
    //dd.setDate(dd.getDate() - 30);

    this.startDatePR = dd;
    this.endDatePR = new Date();
    this.initDatePR =
      this.dateToMDY(this.startDatePR) + " - " + this.dateToMDY(this.endDatePR);
    this.loadInit();
  }, // mounted

  beforeRouteLeave(to, from, next) {
    const isUnSavedValues = this.PatientTasks.some(
      (task) => task.inputNameIcon === true || task.dateChangeIcon === true,
    );
    if (isUnSavedValues === true) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to leave? you have unsaved changes!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, leave it!",
      }).then((result) => {
        if (result.isConfirmed === true) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
};
